import { Link } from 'wouter'

import './WorkshopPage.css'

import TecmaFeatureCard from '../components/TecmaFeatureCard'

const workshopBlocks = [
  {
    eyebrow: 'Agenda',
    title: 'System selection',
    description: 'Walk through the core Tecma choices before the project reaches site.',
    href: '/workshop',
  },
  {
    eyebrow: 'Agenda',
    title: 'Detail checks',
    description: 'Keep interfaces, fixings, and edge conditions visible early.',
    href: '/workshop',
  },
  {
    eyebrow: 'Agenda',
    title: 'Field handoff',
    description: 'Close with a simple path from spec to installation and review.',
    href: '/workshop',
  },
]

export default function WorkshopPage() {
  return (
    <div className="workshop-page space-y-6">
      <section className="border border-white/10 bg-[#151a33] p-6 sm:p-8 lg:p-10">
        <div className="max-w-3xl">
          <p className="text-xs font-black uppercase tracking-[0.28em] text-[#f18a70]">Workshop</p>
          <h1 className="mt-4 text-4xl font-black uppercase leading-[0.94] text-white sm:text-6xl">
            Tecma workshop
            <span className="block text-[#f18a70]">for faster decisions</span>
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-8 text-slate-300 sm:text-lg">
            Workshop view for projects that need a short, direct path from system choice to field execution.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link href="/" className="inline-flex items-center justify-center border border-white/15 bg-white/5 px-5 py-3 text-sm font-bold uppercase tracking-[0.14em] text-white transition hover:bg-white/10">
              Back home
            </Link>
            <a href="#agenda" className="inline-flex items-center justify-center border border-[#f18a70] bg-[#f18a70] px-5 py-3 text-sm font-bold uppercase tracking-[0.14em] text-white transition hover:-translate-y-0.5">
              View agenda
            </a>
          </div>
        </div>
      </section>

      <section id="agenda" className="grid gap-4 lg:grid-cols-3">
        {workshopBlocks.map((block) => (
          <TecmaFeatureCard key={block.title} {...block} />
        ))}
      </section>

      <section className="grid gap-4 border border-white/10 bg-white/5 p-6 sm:p-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.7fr)] lg:items-center">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.24em] text-[#f18a70]">Next step</p>
          <h2 className="mt-3 text-2xl font-black uppercase text-white">Use this route for review, not noise.</h2>
          <p className="mt-2 max-w-2xl text-sm leading-7 text-slate-300">
            Tecma keeps workshop copy short and useful: enough to orient the user and move them to the next decision.
          </p>
        </div>
        <Link href="/" className="inline-flex items-center justify-center border border-white/15 bg-white px-5 py-3 text-sm font-bold uppercase tracking-[0.14em] text-[#0f1324] transition hover:-translate-y-0.5">
          Return home
        </Link>
      </section>
    </div>
  )
}
